// extracted by mini-css-extract-plugin
export default {"page":"ZY-z","cartModal":"_Y-z","checkout":"aZ-z","placeholder":"bZ-z","account":"cZ-z"};